import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 10%;

    @media (max-width: 700px) {
        height: 30%;
        flex-direction: column;
        gap: 15px;
    }
`;

export const Title = styled.div``;

export const H4 = styled.p`
    font-size: 24px;
`;

export const H6 = styled.p`
    font-size: 16px;
    color: ${(props) => props.theme.colors.gray.gray_500};
`;

export const ContentSearch = styled.div`
    display: flex;
    gap: 16px;
    
    @media (max-width: 700px) {
        flex-direction: column;
    }
`;

export const ContentPopButton = styled.div`
    position: relative;
    background-color: transparent;
`;

export const ContentButton = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 10px;
`;